/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CompletedInputs */

const en_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const ar_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتمال`)
};

const de_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossen`)
};

const es_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado`)
};

const fr_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complété`)
};

const it_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completato`)
};

const ja_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const ko_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완료`)
};

const pt_br_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

const ru_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершено`)
};

const th_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียบร้อยแล้ว`)
};

const tr_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamamlandı`)
};

const zh_cn_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

const zh_tw_completed = /** @type {(inputs: CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {CompletedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const completed = /** @type {((inputs?: CompletedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CompletedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_completed(inputs)
	if (locale === "ar") return ar_completed(inputs)
	if (locale === "de") return de_completed(inputs)
	if (locale === "es") return es_completed(inputs)
	if (locale === "fr") return fr_completed(inputs)
	if (locale === "it") return it_completed(inputs)
	if (locale === "ja") return ja_completed(inputs)
	if (locale === "ko") return ko_completed(inputs)
	if (locale === "pt_br") return pt_br_completed(inputs)
	if (locale === "ru") return ru_completed(inputs)
	if (locale === "th") return th_completed(inputs)
	if (locale === "tr") return tr_completed(inputs)
	if (locale === "zh_cn") return zh_cn_completed(inputs)
	return zh_tw_completed(inputs)
});